
// Collection page
var collectionDescriptionElement = document.querySelector(".description_toggle");
var collection_description =  document.querySelectorAll(".collection_description > p");
if (collection_description) {
  document.querySelectorAll(".collection_description > p").forEach(function (item, index) {
      if (index === 0) {
      } else {
          collectionDescriptionElement.appendChild(item.cloneNode(true));
          item.remove();
      }
  });
  
}

var collectionDescription = document.querySelector('.description_toggle');
var btnText = document.getElementById("read-more-btn");
if (btnText) {
  var btnTextSpan = btnText.querySelector('span');
  if (btnTextSpan) {
    var innerHTML = btnTextSpan.innerHTML;
  }
}


if (btnText) {
  var isExpanded = false;
  btnText.onclick = function () {
    collectionDescription.classList.toggle("is-open");
  
    let content = collectionDescription
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
    
    btnTextSpan.innerHTML = isExpanded ? "Read More +" : "Read Less -";
    isExpanded = !isExpanded;
    if(!isExpanded) {
      btnText.classList.add('overlay');
    }
    else {
      btnText.classList.remove('overlay');
    }
  };
  
  if (collectionDescription.textContent.trim().length > 0) {
  }else {
    btnText.style.display = 'none';
  }
}

function toggleReadMore(doc) {
  if(doc){
    var collectionDescriptionElement = doc.querySelector(".description_toggle");
    var collection_description =  doc.querySelectorAll(".collection_description > p");
    if (collection_description) {
      doc.querySelectorAll(".collection_description > p").forEach(function (item, index) {
          if (index === 0) {
          } else {
              collectionDescriptionElement.appendChild(item.cloneNode(true));
              item.remove();
          }
      });
      
    }
  }else{
    var collectionDescriptionElement = document.querySelector(".description_toggle");
    var collection_description =  document.querySelectorAll(".collection_description > p");
    if (collection_description) {
      document.querySelectorAll(".collection_description > p").forEach(function (item, index) {
          if (index === 0) {
          } else {
              collectionDescriptionElement.appendChild(item.cloneNode(true));
              item.remove();
          }
      });
      
    }
  }
  
  if(doc){
    var collectionDescription = doc.querySelector('.description_toggle');
    var btnText = doc.getElementById("read-more-btn");
    if (btnText) {
      var btnTextSpan = btnText.querySelector('span');
      if (btnTextSpan) {
        var innerHTML = btnTextSpan.innerHTML;
      }
    }
  }else{
    var collectionDescription = document.querySelector('.description_toggle');
    var btnText = document.getElementById("read-more-btn");
    if (btnText) {
      var btnTextSpan = btnText.querySelector('span');
      if (btnTextSpan) {
        var innerHTML = btnTextSpan.innerHTML;
      }
    }
  }
  
  
  
  if (btnText) {
    var isExpanded = false;
    btnText.onclick = function () {
      collectionDescription.classList.toggle("is-open");
    
      let content = collectionDescription
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
      
      btnTextSpan.innerHTML = isExpanded ? "Read More +" : "Read Less -";
      isExpanded = !isExpanded;
      if(!isExpanded) {
        btnText.classList.add('overlay');
      }
      else {
        btnText.classList.remove('overlay');
      }
    };
    
    if (collectionDescription.textContent.trim().length > 0) {
    }else {
      btnText.style.display = 'none';
    }
  }
}


// filter on mobile
function filterMobile(){
  var filter_mobile = document.querySelector(".active-facets-vertical-filter .facets__heading");
  var filter_mobile_main = document.querySelector(".facets__form-vertical");
  filter_mobile.onclick = function () {
    filter_mobile_main.classList.toggle("is-open");
  
    let filter_content = document.querySelector('.facets__disclosure-vertical_main');
    if (filter_content.style.maxHeight) {
      filter_content.style.maxHeight = null;
    } else {
      filter_content.style.maxHeight = filter_content.scrollHeight + "px";
    }
  };
  
  document.querySelectorAll(".collection-template-section .facets-vertical .facets__summary").forEach(function (item, index) {
    item.onclick = function (e) {
      setTimeout(function(){
      var filter_content_new = document.querySelector('.facets__disclosure-vertical_main');
        filter_content_new.style.maxHeight = filter_content_new.scrollHeight + "px";
      },100);
    };
   if (item.nextElementSibling.querySelector('.button-show-more') != null ) {
      var itemMoreButton = item.nextElementSibling.querySelector('.button-show-more');
      itemMoreButton.onclick = function (e) {
        setTimeout(function(){
        var filter_content_new = document.querySelector('.facets__disclosure-vertical_main');
          filter_content_new.style.maxHeight = filter_content_new.scrollHeight + "px";
        },100);
      };
   }
  });

}

function filterSortingOrder(){
  var $wrapper = $('ul[label-script="true"]');
  $wrapper.find('li').sort(function (a, b) {
      return +a.dataset.index - +b.dataset.index;
  })
  .appendTo( $wrapper );
}

$(document).ready(function(){
  filterMobile();
  filterSortingOrder();
});








